import type { NavItem } from "../../types";
import { siteUrl } from "../../wordpress";
import "./SideMenu.css";

type SideMenuProps = {
	items: NavItem[];
	open: boolean;
	onClose: () => void;
};

/** Gaveta preta que entra pela esquerda com o menu completo. */
export function SideMenu({ items, open, onClose }: SideMenuProps) {
	return (
		<>
			<div
				className={open ? "side-menu__scrim is-open" : "side-menu__scrim"}
				onClick={onClose}
				aria-hidden="true"
			/>
			<nav
				id="side-menu"
				className={open ? "side-menu is-open" : "side-menu"}
				aria-label="Menú complet"
				aria-hidden={!open}
			>
				<button type="button" className="side-menu__close" onClick={onClose}>
					<span className="visually-hidden">tanca</span>
				</button>
				<ol>
					{/* Pela etiqueta, não pelo href: a gaveta repete destinos
					    (vários itens apontam para /contacte/, por exemplo). */}
					{items.map((item) => (
						<li key={item.label}>
							<a
								href={siteUrl(item.href)}
								onClick={onClose}
								tabIndex={open ? 0 : -1}
								target={item.external ? "_blank" : undefined}
								rel={item.external ? "noreferrer" : undefined}
							>
								{item.label}
							</a>
						</li>
					))}
				</ol>
			</nav>
		</>
	);
}
